import React from 'react'
import PropTypes from 'prop-types'

export default class Gauge extends React.Component {
  render () {
    const { reservas, vagas } = this.props;
    const width = vagas > 0 ? Math.min(reservas / vagas * 100, 100) : 0;
    console.log('Gauge', this.props.vagas, this.props.reservas, width);

    return (
      <div className="progress">
        <div
          className="progress-bar"
          role="progressbar"
          aria-valuenow={reservas}
          aria-valuemin="0"
          aria-valuemax={vagas}
          style={{ width: width + '%' }}
        ></div>
      </div>
    );
  }
}

Gauge.propTypes = {
  vagas: PropTypes.number,
  reservas: PropTypes.number
};

Gauge.defaultProps = {
  vagas: 0,
  reservas: 0
};
